import dayjs from 'dayjs'
import {
  ERROR_MESSAGE_EMAIL_FORMAT,
  ERROR_MESSAGE_EMAIL_DUPLICATED,
} from '~/js/constants/errorMessages'

export const REGEX_KATAKANA = /^[ァ-ヴ]*$/
export const REGEX_PHONE = /^(0\d{9,10}|\+81\d{9,10})$/
export const REGEX_EMAIL = /.+@.+\..+/
export class Customer {
  constructor({ lastName, firstName, acceptsMarketing, metafields }) {
    this.lastName = lastName || ''
    this.firstName = firstName || ''
    this.acceptsMarketing = acceptsMarketing
    this.kanaLastName = metafields.kana_last_name || ''
    this.kanaFirstName = metafields.kana_first_name || ''
    this.gender = metafields.gender || '未設定'

    const thisYear = new Date().getFullYear()
    const year = metafields.bday_year || thisYear - 30
    const month = (metafields.bday_month || 1).toString().padStart(2, '0')
    const day = (metafields.bday_day || 1).toString().padStart(2, '0')
    this.birthdayValue = `${year}-${month}-${day}`
    this.isBirthdayEditable = !metafields.bday_year
  }

  getErrorMessages() {
    const errorMessages = {}
    try {
      errorMessages.lastName = this.getNameError(this.lastName)
      errorMessages.firstName = this.getNameError(this.firstName)
      errorMessages.kanaLastName = this.getKanaError(this.kanaLastName)
      errorMessages.kanaFirstName = this.getKanaError(this.kanaFirstName)
      if (Object.values(errorMessages).filter((v) => v).length)
        throw new Error('入力に不備があります')
    } catch (error) {
      console.error(error)
    }
    return errorMessages
  }

  getNameError(string) {
    if (!string.length) return 'ご入力ください'
    if (string.length > 10) return '10文字以内でご入力ください'
    return null
  }

  getKanaError(string) {
    if (!string.length) return 'ご入力ください'
    if (string.length > 10) return '10文字以内でご入力ください'
    if (!REGEX_KATAKANA.test(string)) return '全角カタカナでご入力ください'
    return null
  }

  static getEmailError(string) {
    if (!string.length) return 'ご入力ください'
    if (!REGEX_EMAIL.test(string)) return ERROR_MESSAGE_EMAIL_FORMAT
    return null
  }

  static getNewEmailError(emailNew, emailCurrent) {
    return (
      this.getEmailError(emailNew) ||
      (emailNew === emailCurrent ? ERROR_MESSAGE_EMAIL_DUPLICATED : null)
    )
  }

  get acceptsMarketingText() {
    return this.acceptsMarketing ? '購読する' : '購読しない'
  }

  get birthdayText() {
    return dayjs(this.birthdayValue).format('YYYY年M月D日')
  }
}
